module.exports = __webpack_public_path__ + "img/RL.574704ca.png";